import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './components/layout/layout.component';
import { NavComponent } from './components/layout/nav.component';
import { FooterComponent } from './components/layout/footer.component';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthModule } from '../auth/auth.module';
import { AppErrorPageComponent } from './components/app-error-page/app-error-page.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { metaReducers, ROOT_REDUCERS } from './store/root.reducers';
import { SharedModule } from '../shared/shared.module';
import { HttpTokenInterceptor } from './interceptors/http-token.interceptor';
import { ApplicativeErrorDialogComponent } from './components/applicative-error-dialog/applicative-error-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LanguageTogglerComponent } from './components/layout/language-toggler.component';
import { PermissionDeniedDialogComponent } from './components/permission-denied-dialog/permission-denied-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { CannotAccessSectionComponent } from './components/cannot-access-section/cannot-access-section.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { LoadingModule } from '../loading/loading.module';
import { LockedEntityInterceptor } from './interceptors/locked-entity.interceptor';
import { NetworkActivityInterceptor } from './interceptors/network-activity.interceptor';

@NgModule({
    exports: [
        LayoutComponent,
        NavComponent,
        FooterComponent,
        StoreModule,
        EffectsModule,
        StoreDevtoolsModule,
        ApplicativeErrorDialogComponent,
        PermissionDeniedDialogComponent,
        PageNotFoundComponent,
        CannotAccessSectionComponent,
        ApplicativeErrorDialogComponent,
    ], imports: [CommonModule,
        FormsModule,
        RouterModule,
        MatDialogModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatListModule,
        MatProgressBarModule,
        LayoutModule,
        AuthModule,
        MatSnackBarModule,
        MatCardModule,
        ClipboardModule,
        MatTooltipModule,
        LoadingModule,
        StoreModule.forRoot(ROOT_REDUCERS, { metaReducers }),
        EffectsModule.forRoot([]),
        StoreDevtoolsModule.instrument({}),
        SharedModule,
        OverlayModule, LayoutComponent,
        NavComponent,
        FooterComponent,
        AppErrorPageComponent,
        ApplicativeErrorDialogComponent,
        LanguageTogglerComponent,
        PermissionDeniedDialogComponent,
        PageNotFoundComponent,
        CannotAccessSectionComponent], providers: [
        // {provide: OverlayContainer, useClass: FullscreenOverlayContainer},
        { provide: HTTP_INTERCEPTORS, useClass: NetworkActivityInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LockedEntityInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule {}
